import * as React from 'react';
import { IBuilderSuggest } from '../../../types/builder';
import { BuilderIcon } from '../../icons';
import { ListGroup, ListItem } from './ListGroup';
import { getSuggestLinkText } from './getSuggestLinkText';
import * as styles from './index.css';

interface IBuilderSuggestionsProps {
  textValue: string;
  suggests: IBuilderSuggest[];
  handleItemSelect(suggest: IBuilderSuggest): void;
}

export const BuilderSuggestions: React.FC<IBuilderSuggestionsProps> = props => {
  const { suggests, textValue, handleItemSelect } = props;

  return (
    <ListGroup title="Застройщики" icon={<BuilderIcon />}>
      {suggests.map(suggest => (
        <ListItem key={`builder-suggestion-${suggest.id}`}>
          <a
            className={styles['list-item_link']}
            target="_blank"
            rel="nofollow noopener"
            onClick={() => handleItemSelect(suggest)}
          >
            <span>{getSuggestLinkText(suggest.name, textValue)}</span>
          </a>
        </ListItem>
      ))}
    </ListGroup>
  );
};
